export const EMPLOYMENT_LOADING = "EMPLOYMENT_LOADING";
export const EMPLOYMENT_SUCCESS = "EMPLOYMENT_SUCCESS";
export const EMPLOYMENT_FAILED = "EMPLOYMENT_FAILED";

export const EMPLOYMENT_ADD_LOADING = "EMPLOYMENT_ADD_LOADING";
export const EMPLOYMENT_ADD_SUCCESS = "EMPLOYMENT_ADD_SUCCESS";
export const EMPLOYMENT_ADD_FAILED = "EMPLOYMENT_ADD_FAILED";

export const EMPLOYMENT_REMOVE_LOADING = "EMPLOYMENT_REMOVE_LOADING";
export const EMPLOYMENT_REMOVE_SUCCESS = "EMPLOYMENT_REMOVE_SUCCESS";
export const EMPLOYMENT_REMOVE_FAILED = "EMPLOYMENT_REMOVE_FAILED";

export const EMPLOYMENT_ANSWER_LOADING = "EMPLOYMENT_ANSWER_LOADING";
export const EMPLOYMENT_ANSWER_SUCCESS = "EMPLOYMENT_ANSWER_SUCCESS";
export const EMPLOYMENT_ANSWER_FAILED = "EMPLOYMENT_ANSWER_FAILED";

export const EMPLOYMENT_SAVE_LOADING = "EMPLOYMENT_SAVE_LOADING";
export const EMPLOYMENT_SAVE_SUCCESS = "EMPLOYMENT_SAVE_SUCCESS";
export const EMPLOYMENT_SAVE_FAILED = "EMPLOYMENT_SAVE_FAILED";

export const VALIDATE_EMPLOYMENT_LOADING = "VALIDATE_EMPLOYMENT_LOADING";
export const VALIDATE_EMPLOYMENT_SUCCESS = "VALIDATE_EMPLOYMENT_SUCCESS";
export const VALIDATE_EMPLOYMENT_FAILED = "VALIDATE_EMPLOYMENT_FAILED";

export const PREVIOUS_EMPLOYMENT_COUNT_LOADING = "PREVIOUS_EMPLOYMENT_COUNT_LOADING";
export const PREVIOUS_EMPLOYMENT_COUNT_SUCCESS = "PREVIOUS_EMPLOYMENT_COUNT_SUCCESS";
export const PREVIOUS_EMPLOYMENT_COUNT_FAILED = "PREVIOUS_EMPLOYMENT_COUNT_FAILED";

export const EMPLOYMENT_VIA_UAN_LOADING = "EMPLOYMENT_VIA_UAN_LOADING";
export const EMPLOYMENT_VIA_UAN_SUCCESS = "EMPLOYMENT_VIA_UAN_SUCCESS";
export const EMPLOYMENT_VIA_UAN_FAILED = "EMPLOYMENT_VIA_UAN_FAILED";

